import React from 'react';
import './GameStats.css';

const GameStats = ({ stats }) => {
  const winPercentage = stats.gamesPlayed > 0
    ? Math.round((stats.wins / stats.gamesPlayed) * 100)
    : 0;

  return (
    <div className="game-stats">
      <h3>Statistics</h3>
      <div className="stats-grid">
        <div className="stat-item wins">
          <span className="stat-number">{stats.wins}</span>
          <span className="stat-label">Wins</span>
        </div>
        <div className="stat-item losses">
          <span className="stat-number">{stats.losses}</span>
          <span className="stat-label">Losses</span>
        </div>
        <div className="stat-item draws">
          <span className="stat-number">{stats.draws}</span>
          <span className="stat-label">Draws</span>
        </div>
        <div className="stat-item total">
          <span className="stat-number">{stats.gamesPlayed}</span>
          <span className="stat-label">Total Games</span>
        </div>
      </div>
      <div className="win-percentage">
        <span className="percentage-label">Win Rate:</span>
        <span className="percentage-value">{winPercentage}%</span>
      </div>
    </div>
  );
};

export default GameStats;